<template>
    <modal :show="isUploading" @close="$emit('accept')">
        <div slot="header">
            <div class="modal-header">
                <h5 class="modal-title">{{ $t('files.uploading_title') }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>

        <div slot="body">
            <div class="alert alert-danger">{{ $t('files.uploading_warning') }}</div>
        </div>

        <div slot="footer">
            <button
                type="button"
                class="btn btn-danger btn-sm"
                @click="$emit('ignore')"
                v-if="action !== 'tab_close'"
            >
                {{ $t('files.continue_button') }}
            </button>
            <button
                type="button"
                class="btn btn-secondary btn-sm"
                data-dismiss="modal"
                @click="$emit('accept')"
            >
                {{ $t('files.close_button') }}
            </button>
        </div>
    </modal>
</template>

<script>

    import {mapState} from "vuex";
    import Modal from '../../components/Modal'

    export default {

        props: {
            action: {
                type: String | null,
                required: false,
                default: null
            }
        },

        components: {
            Modal
        },

        computed: mapState({
            isUploading: state => state.isUploading
        }),

    }

</script>
